import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useEventStore } from "@/store/events/events.store";
import { Event } from "@/models/Events.model";

export const useEvents = () => {
  const { events, setEvents } = useEventStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);

    try {
      await collectionRef.Events.get().then((querySnapshot) => {
        const data: Event[] = [];
        querySnapshot.forEach((doc) => {
          const variation = doc.data() as Event;
          const event = {
            ...variation,
            id: doc.id,
          } as Event;
          data.push(event);
        });
        setEvents(data);
        setLoading(false);
      });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!events) {
      fetchData();
    }
  }, [events]);

  return {
    data: events,
    loading,
    error,
  };
};
